import {frontendURL} from "../../../../helper/URLHelper";

const broadcasts = (accountId) => ({
  parentNav: 'broadcasts',
  routes: ['broadcasts_index'],
  menuItems: [
    {
      icon: 'arrow-swap',
      label: 'ALL_BROADCAST',
      // key: 'listBroadcast',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/broadcasts`),
      toStateName: 'broadcasts_index',
    }
  ],
});


export default broadcasts;
